
import React from 'react';
import style from './style.module.css';
import bg from '../../utils/bg';
const GeoItem = props => {

    const itemData = {
        title: '',
        description: null,
        stat: '',
        photo: null,
        rank: '',
        metric: '',
        appearance: 'g1',
        overlay: ''
    };

    const displayTitle = title => {
        const words = title.split(' ').map(word => word.length >= 16 ? (word.substring(0, 16) + '...') : word);
        return words.join(' ');
    };

    const distance = props.distance(props.data);

    return (
        <div className={style.container}>
            <div className={style.Item + ' ' + style[itemData.appearance]} onClick={props.onSelect}>
                {itemData.stat ? <div className={style.stat}>{itemData.stat}</div> : null}
                {itemData.photo ? (
                    <div className={style.photo} style={{ backgroundImage: bg.url(itemData.photo) }}></div>
                ) : null}
                <div className={style.info}>
                    <div className={style.title}>{displayTitle(props.data.title)}</div>
                    {itemData.description === 'active' ? <div className={style.description}>
                        <div className={style.descriptionLabel}>Active</div>
                    </div> : (itemData.description === 'inactive' ? <div className={style.description}>
                        <div className={style.descriptionLabel}>Not Active</div>
                        {/* <div className={style.iconInactive} /> */}
                    </div> : null)}
                    {/* {itemData.description && itemData.description.length ? <div className={style.description}>{itemData.description}</div> : null} */}
                </div>
                {distance ? (
                    <div className={style.rank}>
                        <div className={style.value}>{distance}</div>
                        <div className={style.metric}>from you</div>
                    </div>
                ) : null}
            </div>
            {itemData.overlay && itemData.overlay.length ? <div className={style.overlay + ' ' + style[itemData.appearance]}>{itemData.overlay}</div> : null}
            {itemData.indicator === 'primary' ? <div className={style.indicatorPrimary} /> : (itemData.indicator === 'secondary' ? <div className={style.indicatorSecondary} /> : (itemData.indicator === 'middle' ? <div className={style.indicatorMiddle} /> : null))}
        </div>
    );

    // itemData.title = props.data.title;
    //     itemData.description = 'desc';
    //     itemData.rank = '5.2 mi.';
    //     itemData.metric = 'from you';
    //     itemData.appearance = props.data.index < 4 ? 'g' + (props.data.index + 1) : 'g4';

};

export default GeoItem;
